import { render, staticRenderFns } from "./CbtAnswers.vue?vue&type=template&id=503abee9&scoped=true"
import script from "./CbtAnswers.vue?vue&type=script&lang=js"
export * from "./CbtAnswers.vue?vue&type=script&lang=js"
import style0 from "./CbtAnswers.vue?vue&type=style&index=0&id=503abee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503abee9",
  null
  
)

export default component.exports